import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
    exportAsPdfFile,
    formatDataForExport,
    formatDate,
    generatePreliminaryHeaders,
    sortObjectKeys,
    titleCase,
} from "../../utils/util.ts";
import * as XLSX from "xlsx";
import "./exports.scss";
import ExportIcon, { DarkExportIcon } from "assets/Icons/icons/ExportIcon.jsx";
import ArrowDown from "assets/Icons/icons/ArrowDown.jsx";
import { useIsDarkTheme } from "helpers/darktheme.js";
import CsvIcon from "assets/Icons/icons/CsvIcon.jsx";
import PdfIcon from "assets/Icons/icons/PdfIcon.jsx";
import { JsonIcon } from "assets/Icons/icons/JsonIcon.jsx";

const Exports = (props) => {
    const { info } = props;
    const [exportData, setExportData] = useState([]);
    const [excelHeader, setExcelHeader] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const isDarkTheme = useIsDarkTheme();

    const title = useMemo(() => {
        let tit = `${info?.title} Count`;
        return tit;
    }, [info]);

    useEffect(() => {
        if (info?.data?.length > 0) {
            let headers = ["Date"];
            const rest = info.data;
            const sortedData = sortObjectKeys(rest[0]?.data);
            sortedData.forEach((row) => {
                const title = titleCase(row[0]);
                headers.push(title);
            });

            setExcelHeader([headers]);

            let tempExportData = [];

            rest.forEach((prev) => {
                let holder = {};
                sortedData.forEach((row) => {
                    holder[row[0]] = prev.data[row[0]];
                });
                tempExportData.push({ date: formatDate(prev.date), ...holder });
            });
            setExportData(tempExportData);
        }
    }, [info]);

    const exportToExcelOrCsv = useCallback(
        (exportAsCsv = false) => {
            if (exportAsCsv) {
            }
            if (!exportAsCsv) {
            }

            if (exportData && exportData.length) {
                const workbook = XLSX.utils.book_new();
                const worksheet = XLSX.utils.json_to_sheet(exportData);
                XLSX.utils.book_append_sheet(workbook, worksheet, "Products");

                // customize header names
                XLSX.utils.sheet_add_aoa(worksheet, excelHeader);

                XLSX.writeFile(
                    workbook,
                    title + (exportAsCsv ? ".csv" : ".xlsx"),
                    {
                        compression: true,
                        bookType: exportAsCsv ? "csv" : "xlsx",
                    }
                );
            }
        },
        [exportData, excelHeader, title]
    );

    const exportToPdf = useCallback(() => {
        if (info?.data) {
            exportAsPdfFile(
                formatDataForExport(info?.data),
                title,
                generatePreliminaryHeaders(info?.data),
                "landscape"
            );
        }
    }, [info, title]);

    const options = [
        {
            label: "CSV",
            icon: <CsvIcon color={isDarkTheme ? "#595959" : "#FFFFFF"} />,
            onClick: () => exportToExcelOrCsv(true),
        },
        {
            label: "PDF",
            icon: <PdfIcon color={isDarkTheme ? "#595959" : "#FFFFFF"} />,
            onClick: () => exportToPdf(),
        },
        {
            label: "EXCEL",
            icon: <JsonIcon color={isDarkTheme ? "#595959" : "#FFFFFF"} />,
            onClick: () => exportToExcelOrCsv(),
        },
    ];

    return (
        <>
            <div className="relative inline-block w-48">
                <button
                    onClick={() => setIsOpen(!isOpen)}
                    className="flex justify-between items-center w-full px-4 py-2 dark:bg-[#424E59] border border-gray-300 dark:border-[#616B74] rounded-lg shadow-md hover:bg-gray-200"
                >
                    <div className="flex gap-2 items-center">
                        {isDarkTheme ? <ExportIcon /> : <DarkExportIcon />}
                        <p className="dark:text-white">Export Data</p>
                    </div>
                    <div className={`${isOpen ? "rotate-180" : ""}`}>
                        <ArrowDown
                            color={isDarkTheme ? "#6B7280" : "#ffffff"}
                        />
                    </div>
                </button>
                {isOpen && (
                    <ul className="absolute w-full mt-1 bg-white dark:bg-[#424E59] border border-gray-300 dark:border-[#616B74] rounded-lg shadow-lg">
                        {options.map((option, index) => (
                            <li
                                key={index}
                                onClick={() => {
                                    option.onClick();
                                    setIsOpen(false);
                                }}
                                className="px-4 py-2 cursor-pointer hover:bg-gray-200 flex items-center dark:text-white"
                            >
                                {option.icon && (
                                    <span className="mr-2">{option.icon}</span>
                                )}
                                {option.label}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </>
    );
};

export default Exports;
